import { render, staticRenderFns } from "./SuiviCA.vue?vue&type=template&id=de0d6d36&scoped=true&"
import script from "./SuiviCA.vue?vue&type=script&lang=ts&"
export * from "./SuiviCA.vue?vue&type=script&lang=ts&"
import style0 from "./SuiviCA.vue?vue&type=style&index=0&id=de0d6d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0d6d36",
  null
  
)

export default component.exports